import { isArray, isObject } from "../utils";

const setDataValue = (parts, value, data) => {
    const currentPart = parts.shift();
    if (parts.length === 0 || (parts.length === 1 && parts[0] === "]")) {
        if (typeof data === "object")
            data[currentPart] = value;
    } else {
        const notVariable = currentPart === "[" || currentPart === "]";
        const currentData = notVariable ? data : data[currentPart];
        if (currentData) {
            setDataValue(parts, value, currentData);
        } else {
            console.warn("Data in server is corrupted for key: " + currentPart, parts)
        }
    }
};

const translationDifferences = (object, translatedObject, callback, prefix = '') => {
    if (isArray(object) && isArray(translatedObject)) {
        object.forEach((entry, index) => {
            if (index < translatedObject.length) {
                translationDifferences(entry, translatedObject[index], callback, `${prefix}[${index}]`)
            }
        })
    } else if (isObject(object) && isObject(translatedObject)) {
        Object.keys(object).forEach(key => {
            if (translatedObject[key] !== undefined && translatedObject[key] !== null) {
                const newPrefix = prefix.length === 0 ? `${key}` : `${prefix}.${key}`
                translationDifferences(object[key], translatedObject[key], callback, newPrefix)
            }
        })
    } else if (object !== translatedObject) {
        callback(prefix, translatedObject)
    }
}

const extractTranslation = ({ data, translatedJson }) => {
    const originalData = data.toJSON()
    const translation = {}
    translationDifferences(originalData, translatedJson, (key, value) => {
        translation[key] = value
    })
    return translation
}

const mergeTranslation = ({ data, dataTranslation }) => {
    const currentDataJson = data.toJSON()
    const langJson = dataTranslation.toJSON();
    for (const [key, value] of Object.entries(langJson)) {
        const parts = key.match(/[a-zäáàëéèíìöóòúùñç][a-zäáàëéèíìöóòúùñç0-9_-]*|[0-9]+(\.[0-9]+)?|(>=|<=|==|!=|>|<)|[:,\(\)\[\]\|]|'(\\'|[^'])*'|"(\\"|[^"])*"/gi);
        setDataValue(parts, value, currentDataJson);
    }
    return currentDataJson
}

const getDataJson = ({ data, currentData, document }) => {
    let currentDataJson = data?.toJSON();
    if (currentData && currentData.startsWith("data-")) {
        const dataTranslation = document.getMap(currentData);
        return mergeTranslation({ data, dataTranslation })
    }
    return currentDataJson;
};


export { getDataJson, mergeTranslation, extractTranslation }